var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { BorderlessButton, BorderlessNotificationButton } from '@citrus/button';
import { Expand } from '@citrus/expand';
import { isNotNilOrEmpty } from '@pcty/utils';
import { getAutomation, getDebug } from '@citrus/runtime';
import { Icon } from '@citrus/icon';
import { icon } from '../styles/legacy';
import { icon as iconCitrus2022, collapisbleCardClosed } from '../styles/citron';
import { CollapsibleCard as Component, CollapsibleHeader as Header, CollapsibleContent as Content, CollapsibleTitle as XTitle, TitleAs, } from './Card.styled';
import { useTheme } from '@citrus/user';
var VERSION = '3.8.0';
var CollapsibleCard = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, _c = _a.contentPadding, contentPadding = _c === void 0 ? true : _c, css = _a.css, headerAs = _a.headerAs, header = _a.header, headerIcon = _a.headerIcon, onClickHeader = _a.onClickHeader, _d = _a.open, open = _d === void 0 ? true : _d, _e = _a.__TYPE, TYPE = _e === void 0 ? 'CollapsibleCard' : _e, other = __rest(_a, ["automationId", "children", "className", "contentPadding", "css", "headerAs", "header", "headerIcon", "onClickHeader", "open", "__TYPE"]);
    var theme = useTheme();
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b[emotionCss(collapisbleCardClosed)] = !open && theme.name === 'citrus2022',
        _b), className || '');
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        renderHeader(header, headerIcon, onClickHeader, automationId, headerAs, open),
        React.createElement(Expand, { collapsedHeight: 0, expanded: open, renderButton: function () { return null; } },
            React.createElement(Content, { contentPadding: contentPadding }, children))));
});
var renderHeader = function (header, headerIcon, onClickHeader, automationId, headerAs, open) {
    if (!header)
        return null;
    // FIXME
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = useTheme();
    var CollapsibleButtonComponent = theme.name === 'citrus2022' ? BorderlessNotificationButton : BorderlessButton;
    var Title = headerAs ? TitleAs(headerAs) : XTitle;
    var headerJsx = (React.createElement(React.Fragment, null,
        React.createElement(Title, __assign({}, getAutomation(automationId, 'title')),
            isNotNilOrEmpty(headerIcon) ? (React.createElement(Icon, __assign({}, (theme.name === 'citrus2022' ? { bold: true } : {}), { className: emotionCss(theme.name === 'citrus2022' ? iconCitrus2022 : icon), name: headerIcon.toLowerCase(), size: theme.name === 'citrus2022' ? 'xsmall' : 'medium' }))) : null,
            header),
        onClickHeader && (React.createElement(CollapsibleButtonComponent, __assign({}, getAutomation(automationId, 'expand-collapse'), (theme.name === 'citrus2022' ? { color: 'black' } : {}), { onClick: onClickHeader }),
            React.createElement(Icon, __assign({ "aria-label": "expand-example" }, (theme.name === 'citrus2022' ? { bold: true } : {}), { name: "chevron-".concat(open ? 'up' : 'down') }))))));
    return React.createElement(Header, null, headerJsx);
};
CollapsibleCard.defaultProps = {
    __TYPE: 'CollapsibleCard',
};
export default CollapsibleCard;
